const url = '218.95.37.217'

export default {
  url
}



// WEBPACK FOOTER //
// ./src/port/getPort.js